import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import useTranslation from '../../../hooks/useTranslation';
import { DIRECTIVE_PENDING_ALERT_DAYS } from '../../../constants/projectOptions';

/**
 * Regles metier de l'onglet Directives, dans un petit bloc repliable.
 * Ferme par defaut ; l'etat est memorise dans le navigateur (localStorage),
 * a titre de confort seulement : sans stockage, le bloc reste simplement ferme.
 */

const STORAGE_KEY = 'onsitepm.directives.rulesOpen';

const readOpen = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const DirectiveRulesHelp = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(readOpen);

  const toggle = () => {
    setOpen((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {
        // Stockage indisponible (navigation privee) : l'etat vit pour la page.
      }
      return next;
    });
  };

  const rules = [
    t('extras.directives.rules.r1'),
    t('extras.directives.rules.r2'),
    t('extras.directives.rules.r3'),
    t('extras.directives.rules.r4', { days: DIRECTIVE_PENDING_ALERT_DAYS }),
  ];

  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        className="inline-flex items-center gap-1.5 text-[11px] font-medium text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary/20 rounded"
      >
        <Icon name="Info" size={12} />
        {t('extras.directives.rules.title')}
        <Icon name={open ? 'ChevronUp' : 'ChevronDown'} size={12} />
      </button>
      {open && (
        <ul className="mt-1.5 ml-1 space-y-1 text-[11px] text-gray-600 bg-white border border-gray-200 rounded-lg px-3 py-2 list-disc list-inside">
          {rules?.map((rule) => <li key={rule}>{rule}</li>)}
        </ul>
      )}
    </div>
  );
};

export default DirectiveRulesHelp;
